export const getJobsByTenantLandscape = /* GraphQL */ `
  query JobsByTenantLandscape($tenantLandscape: String!, $nextToken: String) {
    jobsByTenantLandscape(
      tenantLandscape: $tenantLandscape
      nextToken: $nextToken
    ) {
      items {
        id
        tenant
        landscape
        tenantLandscape
        jobCode
        title
        description
        jobTriggerFilePath
        tasks {
          items {
            version
            product
            batch
            batchName
            versionProductBatch
            includeInDownload
            jobId
            order
            jobIdOrder
            taskMetadata {
              version
              product
              batch
              batchName
              versionProductBatch
              args {
                required
                default
                display
                order
                option
                type
                delimiter
                isMultiple
                isOutputFile
                isInputFile
                isSecret
                isResolvable
                hints {
                  hint
                  language
                }
                labels {
                  label
                  language
                }
                sampleInput
              }
              createdAt
              updatedAt
            }
            title
            args {
              order
              option
              value
              replaceInFileName
            }
            createdAt
            updatedAt
          }
        }
        hasOutputFile
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
